import { useState, useRef } from "react";
import { useSelector } from "react-redux";

import Draggable from "react-draggable";

function CardPreview(props) {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;
  const currentPreviewState = useSelector((state) => state.cardPreview);
  const showCardSignature = !requestDetails.DoNotSignCard;
  const isIndividual = requestDetails.MassTypeValue == "individual";
  const isGregorian = requestDetails.MassTypeValue == "gregorian";
  const showBeginning =
    (currentPreviewState.CardMassDate !== "" &&
      requestDetails.OfferingTime === "consecutivedays" &&
      requestDetails.MassQuantity > 1) ||
    requestDetails.MassQuantity >= 5;
  const isSendToMe = requestDetails.CardTypeValue === "sendtome";
  const isEcard = requestDetails.CardTypeValue === "ecard";
  const showReturnAddress =
    !isSendToMe &&
    requestDetails.UseAddress !== "none" &&
    requestDetails.UseAddress !== "billing";
  const showCustomVerse = currentPreviewState.CustomVerse.trim().length > 0;
  const headingTop = isGregorian ? "52px" : "144px";

  let previewHeight = { height: "auto" };
  if (props.preview) {
    if (props.approve) {
      previewHeight = { height: "102vw" };
    } else {
      previewHeight = { height: "72vw" };
    }
  }

  return (
    <div className="cfg-preview-card-container" style={previewHeight}>
      {props.preview && <p>Tip: Pinch and zoom your screen to explore details more closely!</p>}
      <div
        className="cfg-preview-card"
        style={{ transform: `scale(${props.zoom})` }}
      >
        
        <Draggable>
          <div
            className="cfg-draggable-area"
            style={{ cursor: props.preview ? "default" : "grab" }}
          >
            {props.showCard && (
              <div className="cfg-card-contain">
                <div className="cfg-card inside">
                  <img
                    className="bg-inside-img"
                    src={currentPreviewState.SelectedCard.InsideImage}
                  />
                  <div className="inside-verse">
                    {!showCustomVerse && (
                      <img
                        className="verse-img"
                        src={currentPreviewState.SelectedVerse.VerseImage}
                      />
                    )}
                    {showCustomVerse && (
                      <div className="custom-verse-view parse-new-lines">
                        {currentPreviewState.CustomVerse}
                      </div>
                    )}
                  </div>
                  <div
                    className="inside-text-contain"
                    style={{ paddingTop: headingTop }}
                  >
                    <div className="service-line-single parse-new-lines">
                      {currentPreviewState.CardHeading}
                    </div>
                    <div
                      className={`intention parse-new-lines ${
                        currentPreviewState.FocusedField === "intention"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ marginTop: "18px" }}
                    >
                      {currentPreviewState.CardIntention}
                    </div>
                    <div
                      className="date-header"
                      style={{ marginTop: "0px", display: "none" }}
                    ></div>
                    {currentPreviewState.CardMassDate.length > 0 && (
                      <div
                        className={`mass-date ${
                          currentPreviewState.FocusedField === "massDate"
                            ? "current-field-focus"
                            : ""
                        }`}
                        style={{ marginTop: "18px" }}
                      >
                        {(showBeginning || !isIndividual) && (
                          <span>Beginning </span>
                        )}
                        {currentPreviewState.CardMassDate}
                      </div>
                    )}
                    <div
                      className={`sign-as-lines parse-new-lines ${
                        currentPreviewState.FocusedField === "cardSignature"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ marginTop: "18px" }}
                    >
                      {showCardSignature && (
                        <div>{currentPreviewState.CardSignature}</div>
                      )}
                      {!showCardSignature && (
                        <div>
                          <p className="requested-by">Requested By</p>
                          <p className="signline">&nbsp;</p>
                          <p className="signline">&nbsp;</p>
                          <p className="signline">&nbsp;</p>
                        </div>
                      )}
                    </div>
                    <div
                      className="director-signature"
                      style={{ bottom: "90px" }}
                    >
                      <img
                        src="https://mymassrequest.org/SMAMyMassRequest/media/Images/Signatures/Fr-John-Signature.png"
                        alt="Signature"
                      />
                    </div>
                  </div>
                </div>
                <div className="card front">
                  <img
                    className="cover-img"
                    src={currentPreviewState.SelectedCard.CoverImage}
                  />
                </div>
              </div>
            )}

            {props.showEnvelope && !isEcard && (
              <div className="envelope-contain">
                <div className="envelope-content">
                  <img
                    className="envelope-img"
                    src={
                      currentPreviewState.SelectedCard.EnvelopeBackgroundImage
                    }
                  />

                  {showReturnAddress && (
                    <div
                      className={`envelope-return-addr parse-new-lines ${
                        currentPreviewState.FocusedField === "envelope-return"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ top: "18.0000px", left: "18.0000px" }}
                    >
                      {currentPreviewState.EnvelopeReturnAddress}
                    </div>
                  )}

                  {!isSendToMe && requestDetails.UseAddress === "billing" && (
                    <div
                      className="envelope-return-addr"
                      style={{ top: "18.0000px", left: "18.0000px" }}
                    >
                      Your billing address will print here.
                    </div>
                  )}

                  {!isSendToMe && (
                    <div
                      className={`envelope-recipient-addr parse-new-lines ${
                        currentPreviewState.FocusedField ===
                        "envelope-recipient"
                          ? "current-field-focus"
                          : ""
                      }`}
                      style={{ top: "144.0000px", left: "216.0000px" }}
                    >
                      {currentPreviewState.EnvelopeRecipientAddress}
                    </div>
                  )}

                  {isSendToMe && (
                    <img
                      src="/dist/images/envelope-watermark.png?v=1.0"
                      className="envelope-watermark"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </Draggable>
      </div>
    </div>
  );
}

export default CardPreview;
